<div class="d-flex flex-row justify-content-between w-100">
  <div class="d-flex">
    <a
      *ngIf="isTitleClickable$ | async; else simpleTitle"
      dir="ltr"
      class="title d-flex justify-content-end"
      [routerLink]="link"
      [replaceUrl]="replaceUrl"
      [attr.data-testid]="'MovieDetailsPage.' + (title?.split(' ')?.join('') ?? '') + 'TitleLink'"
      (click)="onCarouselTitleClick()"
      ><h2 class="title-text carousel-title">{{ title }}</h2>
    </a>
    <ng-template #simpleTitle>
      <span>{{ title }}</span>
    </ng-template>
  </div>
  <span *ngIf="isTitleClickable$ | async" class="d-flex explore-title align-items-center flex-shrink-0">
    <a
      class="title d-flex align-items-end"
      [routerLink]="link"
      [replaceUrl]="replaceUrl"
      data-testid="MovieDetailsPage.expandAll"
      (click)="onExpandAllClick()"
      ><span class="explore-all">{{ 'Explore_All' | translate }}</span>
      <span class="arrow mr-2">
        <svg-icon key="right"></svg-icon>
      </span>
    </a>
  </span>
</div>
